import React from 'react';
import { Row, Col, Alert, Button } from 'react-bootstrap';

import OrderDetailBespokeListContainer from '../containers/OrderDetailBespokeListContainer';
import RadioGroup from './common/RadioGroup.jsx';

export default class Fitting1EditSettingsComponent extends React.Component {

  componentDidMount() {
  }

  render() {

    let editDiv = null;
    if (this.props.orderDetail.get('orderDetailId')) {
      editDiv = (
        <div className='box' style={{ padding: 20 }}>
          <Row>
            <Col xs={2} sm={2} md={2}>
              <Button onClick={this.props.editOrderDetail} bsStyle="info">
                修改參數
              </Button>
            </Col>
            <Col xs={10} sm={10} md={10}>
              <Alert bsStyle={this.props.alertStyle}>
                {this.props.alertMessage}
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={12}>
              <label className="control-label" style={{ marginBottom: 20 }}>訂單編號: {this.props.orderId}</label>
            </Col>
            <Col xs={6} sm={6} md={6}>
              <label>編號: {this.props.orderDetail.get('orderDetailId')}</label>
            </Col>
            <Col xs={6} sm={6} md={6}>
              <label>產品名稱: {this.props.orderDetail.get('customerGearName')}</label>
            </Col>
            <Col xs={6} sm={6} md={6}>
              <RadioGroup
                id="bespokeHidden"
                label="套量是否隱藏"
                radioList={[{ label: "Y", value: "Y" }, { label: "N", value: "N" }]}
                value={this.props.orderDetail.get('bespokeHidden')}
                onChange={(id, value) => {
                  this.props.setValue(id, value);
                }}
                validation={this.props.orderDetailValidation.get('bespokeHidden')}
              />
            </Col>
          </Row>
        </div>
      )
    }

    return (
      <div>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={12} md={12}>
            <OrderDetailBespokeListContainer />
          </Col>
        </Row>
        {editDiv}
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/Fitting1EditSettingsComponent.jsx